import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { ProjectsService } from 'src/app/api/projects.service';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { DetailsPage as TaskDetailsPage } from 'src/app/tasks/details/details.page';
import * as dayjs from 'dayjs';
import { CalendarOptions, Calendar } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

@Component({
  selector: 'app-calendar-new',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {

  @ViewChild('appcalendar') calendarComponent: FullCalendarComponent;
  calendarOptions: CalendarOptions;
  calendarAPI: Calendar = null;
  LoadedCalendar = false;

  @Input() show_projects = true;
  @Input() show_tasks = true;
  @Input() show_appointments = false;
  @Input() team_member = '';
  @Input() filter_tasks = true;

  team_members: any[] = [];
  selected_team_member = '';

  constructor(
    private apiService: ApiService,
    private projectService: ProjectsService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    if (this.team_member) {
      this.selected_team_member = this.team_member;
    }
    this.GetAllData();
  }

  async GetAllData() {
    await this.GetTeamMembers();
    this.DrawCalendar();
  }

  async GetTeamMembers() {
    const data: any = await this.apiService.get('team_members');
    if (data.success) {
      this.team_members = data.data;
    }
  }

  DrawCalendar() {
    this.calendarOptions = {
      initialView: 'dayGridMonth',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      eventClick: (info) => this.openEventModal(info.event),
      // Use a function-based event source so refetchEvents() re-runs the filter
      events: (info, successCallback, _failureCallback) => {
        this.GetData(info.startStr, info.endStr, successCallback);
      }
    };

    // Poll until the FullCalendar ViewChild is available in the DOM
    let count = 0;
    const interval = setInterval(() => {
      if (this.calendarComponent) {
        clearInterval(interval);
        this.calendarAPI = this.calendarComponent.getApi();
        window.dispatchEvent(new Event('resize'));
      } else {
        count++;
        if (count > 10) clearInterval(interval);
      }
    }, 500);
  }

  // Called by FullCalendar whenever the view range changes, and manually via refetchEvents()
  async GetData(start: string, end: string, successCallback: (events: any[]) => void) {
    this.LoadedCalendar = false;

    let url_mod = '';
    if (this.selected_team_member === 'unassigned') {
      url_mod = '';
    } else if (this.selected_team_member) {
      url_mod = `&team_member=${this.selected_team_member}`;
    }

    const bufferedStart = dayjs(start).subtract(3, 'day').toISOString();
    const bufferedEnd = dayjs(end).add(3, 'day').toISOString();

    const events = { message: 'Got Data', success: '1', status_code: 200, data: [] };

    if (this.show_projects || this.show_tasks) {
      let projects = await this.projectService.GetProjects(bufferedStart, bufferedEnd, url_mod);
      if (this.show_projects) {
        for (const project of projects) {
          if (project.row_colour == null || project.row_colour == '#FFFFFF') project.row_colour = '#D3D3D3';
          let formatted_event = {
            id: project.guid,
            title: project.title,
            start: project.internal_start_date,
            end: project.internal_end_date,
            color: project.row_colour,
            allDay: true,
            extendedProps: { type: 'project' }
          }
          events.data.push(formatted_event);
        }
        if (this.show_tasks) {
          for (const project of projects) {
            for (const task of project.tasks) {
              console.log('TASK: ', task);
              let formatted_event = {
                id: task.guid,
                title: task.title,
                start: task.start_date,
                end: task.end_date,
                color: task.row_colour,
                allDay: true,
                extendedProps: { type: 'task' }
              }
              events.data.push(formatted_event);
            }
          }

        }

      }
    }
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log("CALENDAR EVENTS: ", events.data);
    successCallback(events.data);
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');
    console.log('~~~~~~~~~~~~~');

    this.LoadedCalendar = true;
    // Let Angular remove [hidden] from the DOM first, then tell FullCalendar
    // to recalculate its container size — otherwise it renders as a blank/stuck grid.
    setTimeout(() => this.calendarAPI?.updateSize(), 0);
  }

  async openEventModal(event: any) {
    const { type } = event.extendedProps;
    const component = type === 'project' ? ProjectDetailsPage : TaskDetailsPage;
    const modal = await this.modalController.create({
      component,
      cssClass: 'large-modal',
      componentProps: { guid: event.id },
      backdropDismiss: false
    });
    modal.onDidDismiss().then(() => this.calendarAPI?.refetchEvents());
    await modal.present();
  }

  // Triggered when the dropdown selection changes
  OnTeamMemberChange() {
    if (this.calendarAPI) {
      this.calendarAPI.refetchEvents();
    }
  }
}
